import {
  GuestReviewTemplate,
  GuestReviewTemplateRatingCategory,
} from 'models/automation/Reviews';
import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export const reviewTemplateSchema = () => ({
  title: Yup.string().required(),
  content: Yup.string().richTextEditorContentRequired(),
  content_htmlContent: Yup.string().required(),
  rate: Yup.number().min(1).max(5).required(),
  isGuestRecommended: Yup.string().oneOf(['yes', 'no']).required(),
  privateFeedback: Yup.string().nullable(),
  cleanliness: Yup.number().min(1).max(5).required(),
  communication: Yup.number().min(1).max(5).required(),
  respectHouseRules: Yup.number().min(1).max(5).required(),
});

export const reviewTemplateSchemaVrbo = () => ({
  rate: Yup.number().min(1).max(5).required(),
  isGuestRecommended: Yup.string().oneOf(['yes', 'no']).required(),
  cleanliness: Yup.number().min(1).max(5).required(),
  communication: Yup.number().min(1).max(5).required(),
  respectHouseRules: Yup.number().min(1).max(5).required(),
});

export type ReviewTemplateSchemaFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof reviewTemplateSchema>>
>;

export type ReviewTemplateSchemaVrboFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof reviewTemplateSchemaVrbo>>
>;

export const getFormDefaultValues = (
  reviewTemplate?: GuestReviewTemplate,
  isVrbo?: boolean,
): ReviewTemplateSchemaFormValues | ReviewTemplateSchemaVrboFormValues => {
  return {
    ...(isVrbo
      ? {}
      : {
          title: reviewTemplate?.title ?? '',
          content: reviewTemplate?.content ?? '',
          content_htmlContent: reviewTemplate?.content ?? '',
          privateFeedback: reviewTemplate?.privateFeedback || null,
        }),

    rate: reviewTemplate?.rate ?? 5,
    isGuestRecommended:
      reviewTemplate?.isGuestRecommended === undefined ||
      reviewTemplate?.isGuestRecommended === true
        ? 'yes'
        : 'no',
    cleanliness:
      reviewTemplate?.ratingCategories.find(
        (category) =>
          category.category === GuestReviewTemplateRatingCategory.CLEANLINESS,
      )?.rate ?? 5,
    communication:
      reviewTemplate?.ratingCategories.find(
        (category) =>
          category.category === GuestReviewTemplateRatingCategory.COMMUNICATION,
      )?.rate ?? 5,
    respectHouseRules:
      reviewTemplate?.ratingCategories.find(
        (category) =>
          category.category ===
          GuestReviewTemplateRatingCategory.RESPECT_HOUSE_RULES,
      )?.rate ?? 5,
  };
};
